import "core-js/modules/esnext.async-iterator.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { getWindow } from "shared/lib/utils";
export const getLocalstorageExtraInformation = () => {
  if (!getWindow()) return {};
  return Object.entries(localStorage).reduce((accumulator, _ref) => {
    let [key, value] = _ref;
    accumulator[key] = new Blob([value]).size;
    return accumulator;
  }, {});
};